export {TsDataTable} from './TsDataTable';
export {TsPagination} from './TsPagination';
export {DEFAULT_PAGE_SIZE, DataTableColumnType} from './ts-data-table.contracts';
export {formatDate} from './ts-data-table.defaults';

export type {
    TsDataTableProps,
    IDataTableColumn,
    IDataTableItem,
    DataTablePaginationState,
    DataTableSortState,
    TranslateFn
} from './ts-data-table.contracts';
